import License from '../Licenses/Model';
export default class Device {
    constructor(values) {
        this.disabled_at = null;
        this.blocked_at = null;
        this.license = null;
        Object.assign(this, values);
        if (values.disabled_at) {
            this.disabled_at = new Date(values.disabled_at);
        }
        if (values.blocked_at) {
            this.disabled_at = new Date(values.blocked_at);
        }
        if (values.license) {
            this.license = new License(values.license);
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Devices/Model.ts
// module id = 353
// module chunks = 0